import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const AccountNumber = props => (
  <BaseInput
    name="accountNumber"
    label="Bank Account Number"
    type="tel"
    autoComplete="off"
    transparent
    maxLength="17"
    validate={val =>
      string()
        .required('Bank Account Number')
        .matches(/^\d{4,17}$/, {
          message: 'Account number should be 4 to 17 numbers'
        })
        .max(17, 'Account number cannot be greater than 17 digits')
        .min(4, ' Account number cannot be less than 4 digits')
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

AccountNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

AccountNumber.defaultProps = {
  value: '',
  error: ''
};

export default AccountNumber;
